import React, { useEffect, useState } from 'react';
import { gAPI_QuestionSets } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { Row, Label, Button, Input, Card, CardBody } from 'reactstrap';
const DynamicFlow = ({
  lang,
  channelDetails,
  saveIntegration,
  propertyList,
}) => {
  const [rows, setRows] = useState(
    channelDetails?.autonomousReplies?.dynamicConversationFlow || []
  );
  const [propertyAssistant, setPropertyAssistant] = useState([]);
  // Handle input changes
  const handleChange = (index, event) => {
    const { name, value } = event.target;
    const updatedRows = [...rows];
    updatedRows[index][name] = value;
    if (name === 'propertyId') handleConversationFlow(value);
    setRows(updatedRows);
  };

  useEffect(() => {
    const callApi = async () => {
      let lstAssistant = [...propertyAssistant];
      if (
        channelDetails?.autonomousReplies?.dynamicConversationFlow &&
        channelDetails?.autonomousReplies?.dynamicConversationFlow.length === 0
      ) {
        if (propertyList !== undefined && propertyList.length > 0) {
          let lst = [];
          const lstPropertesAssistant = propertyList.map(async (p) => {
            lst.push({ propertyId: p.id, dynamicConversationFlowId: '' });
            return AxiosAPI({
              methed: 'get',
              url: `${gAPI_QuestionSets}/?propertyId=${
                p.id
              }&groupId=${getGroupID()}&lang=${lang}`,
            }).then((res) => {
              var setslist = res.data.sets.sort(
                (a, b) => a.displayOrder - b.displayOrder
              );
              var list = [];
              if (setslist !== null && setslist.length > 0) {
                setslist
                  .filter(
                    (l) =>
                      l.type === 'DynamicConversationFlow' &&
                      l.openAiAssistantId !== ''
                  )
                  .map((l) => {
                    list.push({ id: l.openAiAssistantId, name: l.name });
                  });
              }

              lstAssistant.push({ pid: p.id, lst: list });
            });
          });
          Promise.all(lstPropertesAssistant).then((res) => {
            setPropertyAssistant(lstAssistant);
          });
          setRows(lst);
        }
      } else {
        const formsData =
          channelDetails?.autonomousReplies?.dynamicConversationFlow.map(
            (m) => {
              return AxiosAPI({
                methed: 'get',
                url: `${gAPI_QuestionSets}/?propertyId=${
                  m.propertyId
                }&groupId=${getGroupID()}&lang=${lang}`,
              }).then((res) => {
                var setslist = res.data.sets.sort(
                  (a, b) => a.displayOrder - b.displayOrder
                );
                var list = [];
                if (setslist !== null && setslist.length > 0) {
                  setslist
                    .filter(
                      (l) =>
                        l.type === 'DynamicConversationFlow' &&
                        l.openAiAssistantId !== ''
                    )
                    .map((l) => {
                      list.push({ id: l.openAiAssistantId, name: l.name });
                    });
                }

                lstAssistant.push({ pid: m.propertyId, lst: list });
              });
            }
          );
        Promise.all(formsData).then((res) => {
          setPropertyAssistant(lstAssistant);
        });
      }
    };
    callApi();
  }, [propertyList]);

  const [autonomousSettings, setAutonomousSettings] = useState(
    channelDetails?.autonomousReplies
  );

  const handleSave = () => {
    let settings = autonomousSettings;
    settings.dynamicConversationFlow = [...rows];
    channelDetails.autonomousReplies = autonomousSettings;
    saveIntegration({ channelDetails });
  };

  const handleConversationFlow = async (pid) => {
    let lst = [...propertyAssistant];
    if (lst.filter((f) => f.pid == pid).length === 0) {
      await AxiosAPI({
        methed: 'get',
        url: `${gAPI_QuestionSets}/?propertyId=${pid}&groupId=${getGroupID()}&lang=${lang}`,
      })
        .then((res) => {
          var setslist = res.data.sets.sort(
            (a, b) => a.displayOrder - b.displayOrder
          );
          var list = [];
          if (setslist !== null && setslist.length > 0) {
            setslist
              .filter(
                (l) =>
                  l.type === 'DynamicConversationFlow' &&
                  l.openAiAssistantId !== ''
              )
              .map((l) => {
                list.push({ id: l.openAiAssistantId, name: l.name });
              });
          }

          lst.push({ pid: pid, lst: list });
          setPropertyAssistant(lst);
        })
        .catch((err) => {
          console.error(
            'API error:',
            err.response ? err.response.data : err.message
          );
        });
    } else setPropertyAssistant(lst);
  };

  return (
    <Card className="mb-4">
      <CardBody>
        <div className="text-center mb-2">
          <h5>Dynamic Conversation Flow</h5>
        </div>
        <Separator className="mb-3" />
        <div className="row mt-2 ml-2 mb-3">
          {rows.map((m, index) => (
            <Row className="mb-2 w-100">
              <Colxx md={6} className="mb-3">
                <Label>Property</Label>
                <Input
                  type="select"
                  value={m.propertyId}
                  name="propertyId"
                  style={{ width: '100%' }}
                  onChange={(e) => handleChange(index, e)}
                >
                  <option value="">Please Select</option>
                  {propertyList &&
                    propertyList.map((p) => (
                      <option value={p.id}>{p.name}</option>
                    ))}
                </Input>
              </Colxx>
              <Colxx md={6} className="mb-3">
                <Label>Conversation Flow</Label>
                <Input
                  type="select"
                  name="dynamicConversationFlowId"
                  placeholder="Dynamic Conversation Flow"
                  value={m?.dynamicConversationFlowId}
                  style={{ width: '100%' }}
                  onChange={(e) => handleChange(index, e)}
                >
                  <option value="">Select a Dynamic Conversation Flow</option>
                  {propertyAssistant?.length > 0 &&
                    propertyAssistant?.filter((f) => f.pid == m.propertyId)
                      .length > 0 &&
                    propertyAssistant
                      ?.filter((f) => f.pid == m.propertyId)[0]
                      .lst.map((assist, index) => (
                        <option key={index} value={assist.id}>
                          {`${assist.name} (${assist.id})`}
                        </option>
                      ))}
                </Input>
              </Colxx>
            </Row>
          ))}
        </div>
        <Separator className="mb-2" />
        <Colxx md="12" className="text-center mb-2">
          <Button onClick={() => handleSave()} color="primary" size="xs">
            Save
          </Button>
        </Colxx>
      </CardBody>
    </Card>
  );
};

export default DynamicFlow;
